// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"2530":"c2218d1e6e03877b","6511":"5ebbefa1ae73aeac"}[chunkId] + ".js";
};